import styled from 'styled-components';

export const EditBtn = styled.button`
    background-color: #4CAF50;
    color: white;
    padding: 12px 20px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
`;

export const PaymentStatusWrapper = styled.div`
    padding: 10px;
    background-color: rgba(255,255,255,0.2);
`;